import { Alert as AtomAlert } from '@/components/atoms/alert/Alert'

import { PropsAlert } from '../types/alertType'

/**
 * Alert dapat memberitahu pengguna tentang informasi yang penting atau yang memerlukan tindakan segera. Alert dapat berupa pesan pop-up, banner informasi, atau notifikasi dalam bentuk lain yang mudah dilihat dan diakses oleh pengguna.
 */

const icons: Record<NonNullable<PropsAlert['variant']>, string> = {
  primary: 'tabler:info-circle',
  danger: 'tabler:alert-triangle',
  warning: 'tabler:alert-circle',
  success: 'tabler:check'
}

export const Alert = ({ title, variant = 'success', children, ...props }: PropsAlert) => (
  <AtomAlert title={title} color={variant} icon={icons[variant]} action={children} {...props} />
)
